<template>
  <div>
    <div class="base-wrap clearfix">
      <div class="base-item">
        <em class="label">用款事由：</em>
        <div class="content">
          {{formData.title }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">我方公司：</em>
        <div class="content">
          {{ formData.owner_company_info && formData.owner_company_info.name || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">对方公司：</em>
        <div class="content">
          {{ formData.other_company_info && formData.other_company_info.name || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">对方银行：</em>
        <div class="content">
          {{ formData.other_bank_info && formData.other_bank_info.name || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">对方开户行：</em>
        <div class="content">
          {{ formData.other_bank_info && formData.other_bank_info.address || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">对方银行账号：</em>
        <div class="content">
          {{ formData.other_bank_info && formData.other_bank_info.number || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">最晚付款日期：</em>
        <div class="content">
          {{ formData.last_pay_time || '--/--' }}
        </div>
      </div>
      <div class="base-item">
        <em class="label">币种类型：</em>
        <div class="content" v-if="formData.coin_type">
          {{ coins.constMap.idMap[formData.coin_type].name  || '--/--'}}
        </div>
      </div>
      <div class="base-item">
        <em class="label">总金额：</em>
        <div class="content">
          {{formData.format_sum_money}}
          <span
            v-if="formData.coin_type">{{ coins.constMap.idMap[formData.coin_type].tailUnit}}</span>
        </div>
      </div>
      <div class="base-item">
        <em class="label">备注信息：</em>
        <div class="content">
          {{formData.remark || '--/--'}}
        </div>
      </div>
      <div class="base-item" v-if=" approveType != 4">
        <em class="label">附件：</em>
        <div class="content" v-if="formData.img_keys&& formData.img_keys.length>0">
          <template v-for="img in formData.img_keys">
            <a style="color: #2f78ff;" :key='img.key'
              :href="`/api/base/download?key=${img.key}`"
              target="_blank">{{img.name}}&nbsp;&nbsp;</a>&nbsp;
          </template>
        </div>
        <div class="content" v-else>--/--</div>
      </div>
    </div>


  </div>
</template>

<script>
import { coins } from '@/const'
export default {
  name: 'clientRefundDetail', // 客户退款
  props: {
    formData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    expenseTypes: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  computed: {
    approveType() {
      return this.$route.query.type
    }
  },
  created() {
    console.log('approveType', this.approveType)
  },
  methods: {
   
  },
  data() {
    return {
      coins,
    }
  },
}
</script>
